import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export function as(component, asProp) {
  const Component = component; // For an unknown reason, using StyledComponentProps instead of ComponentProps here introduce a huge performance problem for TS.

  return /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(Component, {
    as: asProp,
    ref: ref,
    ...props
  }));
}